import _regeneratorRuntime from 'babel-runtime/regenerator';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import Geocode from "react-geocode";
import Switch from '@material-ui/core/Switch';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ExploreIcon from '@material-ui/icons/Explore';
import { withTranslation } from 'react-i18next';
import config from '../../../../config';
import check0 from './img/check0.png'; // desactivado
import check1 from './img/check1.png'; // activado
import check2 from './img/check2.png'; // pendiente de desactivar
import check3 from './img/check3.png'; // pendiente de activar
Geocode.setApiKey("AIzaSyDseP7HF_56aFB57irUQeEi5438tD4PSlk");

var layerDevicesContent = function (_Component) {
    _inherits(layerDevicesContent, _Component);

    function layerDevicesContent(props) {
        var _this2 = this;

        _classCallCheck(this, layerDevicesContent);

        var _this = _possibleConstructorReturn(this, (layerDevicesContent.__proto__ || Object.getPrototypeOf(layerDevicesContent)).call(this, props));

        _this.handleOnclick = function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
                var location;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                e.preventDefault();

                                if (!(_this.props.device.assetsIOTInfo !== undefined)) {
                                    _context.next = 11;
                                    break;
                                }

                                if (_this.state.isOpen) {
                                    _context.next = 10;
                                    break;
                                }

                                _context.next = 5;
                                return _this.getAddress(_this.props.device.assetsIOTInfo[0].gpsInfo.latitude, _this.props.device.assetsIOTInfo[0].gpsInfo.longitude);

                            case 5:
                                location = _context.sent;

                                _this.calc(_this.props.device.assetsIOTInfo[0].gpsInfo.latitude);

                                _this.setState({
                                    address: location,
                                    isOpen: !_this.state.isOpen
                                });

                                _context.next = 11;
                                break;

                            case 10:
                                _this.setState({
                                    isOpen: !_this.state.isOpen
                                });

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.handleOnChangeCheckBox = function (e) {
            _this.props.filterForDevice(_this.props.device.assetsInfoImei, e.target.checked);
        };

        _this.handleOnClickActivators = function (index) {

            // Copia el array activators para no modificar el estado directamente
            var updatedActivators = [].concat(_toConsumableArray(_this.props.device.assetsIOTInfo[0].gOUTValue));

            // Obtiene el estado actual del activador en el índice correspondiente
            var currentState = updatedActivators[index].state;

            // Verifica si el estado es "pendiente de activar" o "pendiente de desactivar"
            if (currentState === "pendiente de activar" || currentState === "pendiente de desactivar") {
                // Ignora el clic en estos casos
                return;
            }

            // Define la lógica para cambiar de estado y src
            var newState = void 0,
                newSrc = void 0;

            if (currentState === "desactivado") {
                newState = "pendiente de activar";
                newSrc = check3; // Cambia a la imagen check3
            } else if (currentState === "activado") {
                newState = "pendiente de desactivar";
                newSrc = check2; // Cambia a la imagen check2
            }

            // Actualiza el estado del activador en el índice correspondiente
            updatedActivators[index] = Object.assign({}, updatedActivators[index], {
                state: newState,
                src: newSrc
            });

            _this.saveDataActivators(updatedActivators, index);

            // Actualiza el estado con el nuevo array de activadores
            _this.props.device.assetsIOTInfo[0].gOUTValue = updatedActivators;
            _this.setState({ activators: updatedActivators });
        };

        _this.saveDataActivators = function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(updatedActivators, index) {
                var requestBody, response, data;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                requestBody = {
                                    // Coloca aquí los datos que deseas enviar en el cuerpo de la solicitud
                                    vehicleId: _this.props.id,
                                    gout: index + 1,
                                    activate: updatedActivators[index].state === "pendiente de activar" ? true : false
                                };
                                //console.log(requestBody)

                                _context2.next = 4;
                                return fetch(config.URL + 'AssetsIotInfo/GOUT', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'accessToken': _this.props.accessToken
                                    },
                                    body: JSON.stringify(requestBody)
                                });

                            case 4:
                                response = _context2.sent;

                                if (response.ok) {
                                    _context2.next = 7;
                                    break;
                                }

                                throw new Error('Error en la solicitud: ' + response.status);

                            case 7:
                                _context2.next = 9;
                                return response.json();

                            case 9:
                                data = _context2.sent;
                                _context2.next = 15;
                                break;

                            case 12:
                                _context2.prev = 12;
                                _context2.t0 = _context2['catch'](0);

                                console.error('Error al obtener datos:', _context2.t0.message);

                            case 15:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2, [[0, 12]]);
            }));

            return function (_x2, _x3) {
                return _ref2.apply(this, arguments);
            };
        }();

        _this.adaptState = function (values) {
            return values.map(function (value) {
                switch (value) {
                    case 0:
                        return { src: check0, state: "desactivado" };
                    case 1:
                        return { src: check1, state: "activado" };
                    case 2:
                        return { src: check2, state: "pendiente de activar" };
                    case 3:
                        return { src: check3, state: "pendiente de desactivar" };
                    default:
                        return { src: check0, state: "desactivado" };
                }
            });
        };

        _this.state = {
            stateClass: '',
            stateIconClass: '',
            label: '',
            valueFilter: '',
            address: undefined,
            isOpen: false,
            isFollowDevice: false,
            activators: []
            // activators: [
            //     { src: check0, state: "desactivado" },
            //     { src: check1, state: "activado" },
            //     { src: check2, state: "pendiente de desactivar" },
            //     { src: check3, state: "pendiente de activar" },
            // ]
        };
        return _this;
    }

    _createClass(layerDevicesContent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // this.setState({
            //     childClass: 'child low'
            // }, () => {
            //     $("#layerDevicesContent").slideDown("slow");
            // });


        }
    }, {
        key: 'getAddress',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(lat, lng) {
                var address, response;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!(lat !== 0)) {
                                    _context3.next = 14;
                                    break;
                                }

                                lat = lat.toString();
                                lng = lng.toString();

                                _context3.next = 5;
                                return fetch(config.URL + ('maps?lat=' + lat + '&lon=' + lng));

                            case 5:
                                address = _context3.sent;

                                if (!address.ok) {
                                    _context3.next = 13;
                                    break;
                                }

                                _context3.next = 9;
                                return address.text();

                            case 9:
                                response = _context3.sent;
                                return _context3.abrupt('return', response);

                            case 13:
                                alert("HTTP-Error: " + address.status);

                            case 14:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function getAddress(_x4, _x5) {
                return _ref3.apply(this, arguments);
            }

            return getAddress;
        }()
    }, {
        key: 'calc',
        value: function calc(num) {
            var with6Decimals = num.toString().match(/^-?\d+(?:\.\d{0,4})?/)[0];
            return with6Decimals;
        }
    }, {
        key: 'getBase4',
        value: function getBase4(val) {
            var res = [0, 0, 0, 0];

            if (val <= 255) {
                if (val < 4) {
                    res[3] = val;
                } else {
                    var cociente = val;
                    var resAux = [0, 0, 0, 0];
                    var i = 0;

                    while (cociente >= 4) {
                        resAux[i] = cociente % 4;
                        cociente = Math.floor(cociente / 4);
                        i++;
                    }
                    resAux[i] = cociente;

                    switch (i) {
                        case 1:
                            res[2] = resAux[1];
                            res[3] = resAux[0];
                            break;
                        case 2:
                            res[1] = resAux[2];
                            res[2] = resAux[1];
                            res[3] = resAux[0];
                            break;
                        case 3:
                            res[0] = resAux[3];
                            res[1] = resAux[2];
                            res[2] = resAux[1];
                            res[3] = resAux[0];
                            break;
                    }
                }
            } else {
                res = [1, 1, 1, 1];
            }

            return res.reverse();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            // console.log("render - layerDevicesContent");
            var t = this.props.t;

            var classNameCollapse = "";
            var canBuss = {};
            var temperature = {};
            if (this.props.device.assetsIOTInfo !== undefined) {
                if (this.props.centerDevice === this.props.device.assetsIOTImei) {
                    // console.log(this.props.centerDevice + " " + this.props.device.assetsIOTImei)
                    classNameCollapse = "collapse show";
                } else {
                    classNameCollapse = "collapse";
                }
            }
            if (this.props.device.assetsIOTInfo !== undefined) {
                canBuss = this.props.device.assetsIOTInfo[0].canInfo;
                temperature = this.props.device.assetsIOTInfo[0].temperatura;
            }

            return React.createElement(
                'div',
                { className: 'panel-body' },
                React.createElement(
                    'div',
                    { className: 'panel-group' },
                    React.createElement(
                        'div',
                        { className: 'panel panel-default sub-group-content sub-group-1' },
                        React.createElement(
                            'label',
                            { 'class': 'containerCheck', style: { position: "absolute", marginTop: "8px", marginLeft: "12px" } },
                            React.createElement('input', { type: 'checkbox', onChange: this.handleOnChangeCheckBox,
                                checked: this.props.device.isChecked }),
                            React.createElement('span', { style: { marginTop: "0px" }, 'class': 'checkmark' })
                        ),
                        React.createElement(
                            'a',
                            { 'data-toggle': 'collapse', 'data-parent': '#accordion',
                                href: "#group-1-level-2__" + this.props.id },
                            React.createElement(
                                'div',
                                { className: 'panel-heading map-content-level2', onClick: this.handleOnclick },
                                React.createElement(
                                    'div',
                                    { className: 'panel-title' },
                                    React.createElement(
                                        'div',
                                        { className: 'level2-heading' },
                                        React.createElement(
                                            'div',
                                            { className: 'level2-heading-left' },
                                            React.createElement('span', { className: "bg-left " + this.state.stateClass }),
                                            React.createElement('span', { style: { position: "relative", top: "2px", marginLeft: "26px" }, className: this.state.stateIconClass }),
                                            React.createElement(
                                                'span',
                                                { className: 'trackerName' },
                                                this.props.device.assetsInfoName
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        React.createElement('div', { className: 'clearfix' }),
                        React.createElement(
                            'div',
                            { id: "group-1-level-2__" + this.props.id, className: classNameCollapse },
                            React.createElement(
                                'div',
                                { className: 'panel-body level2-content' },
                                React.createElement(
                                    'div',
                                    { className: 'level2-content-top' },
                                    React.createElement(
                                        'div',
                                        { className: 'level2-content-top-inner clearfix' },
                                        React.createElement(
                                            'ul',
                                            { className: 'level2-driver-details list-unstyled' },
                                            React.createElement(
                                                'li',
                                                null,
                                                this.props.device.assetsIOTInfo !== undefined ? this.props.device.assetsIOTInfo[0].gpsInfo.timestamp : this.props.device.gpsInfo.timestamp
                                            ),
                                            this.props.device.assetsInfoDriverName != "" && React.createElement(
                                                'li',
                                                null,
                                                'Conductor: ',
                                                this.props.device.assetsInfoDriverName
                                            ),
                                            this.props.permisionActivator && React.createElement(
                                                'li',
                                                null,
                                                React.createElement(
                                                    'div',
                                                    { style: { marginTop: 25, width: "113px", height: "25px", background: "#E6E6E6" } },
                                                    this.props.device.assetsIOTInfo[0].gOUTValue.length > 0 && this.props.device.assetsIOTInfo[0].gOUTValue.map(function (activator, index) {
                                                        return React.createElement('img', {
                                                            key: index,
                                                            onClick: function onClick() {
                                                                return _this3.handleOnClickActivators(index);
                                                            },
                                                            style: { width: "13px", height: "14px", cursor: "pointer", position: "relative", float: "left", top: "5px", margin: "0px 5px", left: "10px", verticalAlign: "middle" },
                                                            src: activator.src
                                                        });
                                                    })
                                                )
                                            )
                                        ),
                                        React.createElement(
                                            'ul',
                                            { className: 'level2-driving-details list-unstyled' },
                                            React.createElement(
                                                'li',
                                                null,
                                                this.state.label
                                            ),
                                            React.createElement(
                                                'li',
                                                null,
                                                'ID ',
                                                this.props.device.id !== undefined ? this.props.device.id : this.props.device.assetsIOTInfo[0].id
                                            ),
                                            React.createElement(
                                                'li',
                                                null,
                                                React.createElement(ExploreIcon, { style: { color: "#575756", marginTop: "5px", cursor: "pointer" }, onClick: this.props.device.assetsIOTInfo !== undefined ? this.props.centerMapWihtOutFollow.bind(this, this.props.device.assetsIOTInfo[0].gpsInfo.latitude, this.props.device.assetsIOTInfo[0].gpsInfo.longitude, this.props.device, this.state.address) : this.props.centerMapWihtOutFollow.bind(this, this.props.device.gpsInfo.latitude, this.props.device.gpsInfo.longitude) })
                                            )
                                        )
                                    ),
                                    React.createElement(
                                        'div',
                                        { className: 'level2-content-inner' },
                                        React.createElement(
                                            'p',
                                            { className: 'level2-address' },
                                            this.state.address !== undefined ? this.state.address : this.props.address
                                        ),
                                        React.createElement(
                                            'p',
                                            { className: 'level2-gps' },
                                            'LAT: ',
                                            this.props.device.assetsIOTInfo !== undefined ? this.calc(this.props.device.assetsIOTInfo[0].gpsInfo.latitude) : this.calc(this.props.device.gpsInfo.latitude),
                                            ' ',
                                            React.createElement('br', null),
                                            'LONG: ',
                                            this.props.device.assetsIOTInfo !== undefined ? this.calc(this.props.device.assetsIOTInfo[0].gpsInfo.longitude) : this.calc(this.props.device.gpsInfo.longitude)
                                        )
                                    )
                                ),
                                React.createElement(
                                    'div',
                                    { className: 'level2-content-middle' },
                                    React.createElement(
                                        'ul',
                                        { className: 'list-unstyled', style: { alignItems: "center", padding: "0px" } },
                                        React.createElement(
                                            'li',
                                            null,
                                            React.createElement('span', { className: 'icon-gauge' }),
                                            React.createElement(
                                                'span',
                                                null,
                                                this.props.device.assetsIOTInfo !== undefined ? this.props.device.assetsIOTInfo[0].gpsInfo.speed : this.props.device.gpsInfo.speed,
                                                ' km/h'
                                            )
                                        ),
                                        React.createElement(
                                            FormGroup,
                                            { 'aria-label': 'position', style: { fontSize: "10px", marginRight: "10px" }, row: true },
                                            React.createElement(FormControlLabel, {
                                                value: 'start',
                                                control: React.createElement(Switch, { checked: this.props.device.assetsIOTInfo !== undefined ? this.props.centerDevice === this.props.device.assetsIOTInfo[0].assetsIOTImei && this.props.isOpenDeviceContent ? true : false : this.props.centerDevice === this.props.device.assetsIOTImei && this.props.isOpenDeviceContent ? true : false, onClick: this.props.device.assetsIOTInfo !== undefined ? this.props.setLatLng.bind(this, this.props.device.assetsIOTInfo[0].gpsInfo.latitude, this.props.device.assetsIOTInfo[0].gpsInfo.longitude, this.props.device.assetsIOTInfo[0].assetsIOTImei) : this.props.setLatLng.bind(this, this.props.device.gpsInfo.latitude, this.props.device.gpsInfo.longitude, this.props.device.assetsIOTImei), inputProps: { 'aria-label': 'secondary checkbox' } }),
                                                label: t("map.sidebar.devicesContent.tracking"),
                                                labelPlacement: 'start'
                                            })
                                        )
                                    )
                                ),
                                React.createElement(
                                    'div',
                                    { className: 'level2-content-bottom' },
                                    React.createElement(
                                        'div',
                                        { className: 'panel-group' },
                                        canBuss.odometro != 0 || canBuss.fuelPorcentage != 0 || canBuss.fuelLiters != 0 ? React.createElement(
                                            'div',
                                            { className: 'panel panel-default map-content-level3' },
                                            React.createElement(
                                                'a',
                                                { 'data-toggle': 'collapse',
                                                    'data-parent': '#group-1-level-2__1-level-3__2',
                                                    href: "#group-1-level-2__1-level-3__2" + this.props.id },
                                                React.createElement(
                                                    'div',
                                                    { className: 'panel-heading' },
                                                    React.createElement(
                                                        'div',
                                                        { className: 'panel-title' },
                                                        React.createElement(
                                                            'div',
                                                            { className: 'level3-heading' },
                                                            React.createElement(
                                                                'div',
                                                                { className: 'level3-heading-left' },
                                                                React.createElement(
                                                                    'span',
                                                                    null,
                                                                    'CAN-BUS'
                                                                )
                                                            ),
                                                            React.createElement(
                                                                'div',
                                                                { className: 'level3-heading-right' },
                                                                React.createElement(
                                                                    'span',
                                                                    null,
                                                                    React.createElement('span', {
                                                                        className: 'icon-colapse_down' })
                                                                )
                                                            ),
                                                            React.createElement('div', { className: 'clearfix' })
                                                        )
                                                    ),
                                                    React.createElement('div', { className: 'clearfix' })
                                                )
                                            ),
                                            React.createElement(
                                                'div',
                                                { id: "group-1-level-2__1-level-3__2" + this.props.id,
                                                    className: 'panel-collapse collapse map-content-level3' },
                                                React.createElement(
                                                    'div',
                                                    { className: 'panel-body' },
                                                    React.createElement(
                                                        'div',
                                                        { className: 'panel-body' },
                                                        React.createElement(
                                                            'table',
                                                            null,
                                                            React.createElement(
                                                                'tbody',
                                                                null,
                                                                this.props.device.assetsIOTInfo[0].canInfo.odometro != 0 && React.createElement(
                                                                    'tr',
                                                                    null,
                                                                    React.createElement(
                                                                        'td',
                                                                        null,
                                                                        t("map.sidebar.devicesContent.odometer")
                                                                    ),
                                                                    React.createElement(
                                                                        'td',
                                                                        null,
                                                                        this.props.device.assetsIOTInfo[0].canInfo.odometro,
                                                                        ' km'
                                                                    )
                                                                ),
                                                                this.props.device.assetsIOTInfo[0].canInfo.fuelPorcentage != 0 && React.createElement(
                                                                    'tr',
                                                                    null,
                                                                    React.createElement(
                                                                        'td',
                                                                        null,
                                                                        t("map.sidebar.devicesContent.fuel")
                                                                    ),
                                                                    React.createElement(
                                                                        'td',
                                                                        null,
                                                                        this.props.device.assetsIOTInfo[0].canInfo.fuelPorcentage,
                                                                        ' %'
                                                                    )
                                                                ),
                                                                this.props.device.assetsIOTInfo[0].canInfo.fuelLiters != 0 && React.createElement(
                                                                    'tr',
                                                                    null,
                                                                    React.createElement(
                                                                        'td',
                                                                        null,
                                                                        t("map.sidebar.devicesContent.fuel")
                                                                    ),
                                                                    React.createElement(
                                                                        'td',
                                                                        null,
                                                                        this.props.device.assetsIOTInfo[0].canInfo.fuelLiters,
                                                                        ' L'
                                                                    )
                                                                )
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        ) : null,
                                        temperature && temperature.temp ? React.createElement(
                                            'div',
                                            { className: 'panel panel-default map-content-level3' },
                                            React.createElement(
                                                'a',
                                                { 'data-toggle': 'collapse',
                                                    'data-parent': '#group-1-level-2__1-level-3__3',
                                                    href: "#group-1-level-2__1-level-3__3" + this.props.id },
                                                React.createElement(
                                                    'div',
                                                    { className: 'panel-heading' },
                                                    React.createElement(
                                                        'div',
                                                        { className: 'panel-title' },
                                                        React.createElement(
                                                            'div',
                                                            { className: 'level3-heading' },
                                                            React.createElement(
                                                                'div',
                                                                { className: 'level3-heading-left' },
                                                                React.createElement(
                                                                    'span',
                                                                    null,
                                                                    t("map.sidebar.devicesContent.temperature")
                                                                )
                                                            ),
                                                            React.createElement(
                                                                'div',
                                                                { className: 'level3-heading-right' },
                                                                React.createElement(
                                                                    'span',
                                                                    null,
                                                                    React.createElement('span', {
                                                                        className: 'icon-colapse_down' })
                                                                )
                                                            ),
                                                            React.createElement('div', { className: 'clearfix' })
                                                        )
                                                    ),
                                                    React.createElement('div', { className: 'clearfix' })
                                                )
                                            ),
                                            React.createElement(
                                                'div',
                                                { id: "group-1-level-2__1-level-3__3" + this.props.id,
                                                    className: 'panel-collapse collapse map-content-level3' },
                                                React.createElement(
                                                    'div',
                                                    { className: 'panel-body' },
                                                    React.createElement(
                                                        'table',
                                                        null,
                                                        React.createElement(
                                                            'tbody',
                                                            null,
                                                            temperature.temp[0].temp < 150 && React.createElement(
                                                                'tr',
                                                                null,
                                                                React.createElement(
                                                                    'td',
                                                                    null,
                                                                    'T1'
                                                                ),
                                                                React.createElement(
                                                                    'td',
                                                                    null,
                                                                    temperature.temp[0].temp,
                                                                    React.createElement(
                                                                        'sup',
                                                                        null,
                                                                        '\xBA'
                                                                    ),
                                                                    ' ',
                                                                    temperature.temp[0].hum > 0 ? '(' + temperature.temp[0].hum + '%)' : ""
                                                                )
                                                            ),
                                                            temperature.temp[1].temp < 150 && React.createElement(
                                                                'tr',
                                                                null,
                                                                React.createElement(
                                                                    'td',
                                                                    null,
                                                                    'T2'
                                                                ),
                                                                React.createElement(
                                                                    'td',
                                                                    null,
                                                                    temperature.temp[1].temp,
                                                                    React.createElement(
                                                                        'sup',
                                                                        null,
                                                                        '\xBA'
                                                                    ),
                                                                    temperature.temp[1].hum > 0 ? '(' + temperature.temp[1].hum + '%)' : ""
                                                                )
                                                            ),
                                                            temperature.temp[2].temp < 150 && React.createElement(
                                                                'tr',
                                                                null,
                                                                React.createElement(
                                                                    'td',
                                                                    null,
                                                                    'T3'
                                                                ),
                                                                React.createElement(
                                                                    'td',
                                                                    null,
                                                                    temperature.temp[2].temp,
                                                                    React.createElement(
                                                                        'sup',
                                                                        null,
                                                                        '\xBA'
                                                                    ),
                                                                    temperature.temp[2].hum > 0 ? '(' + temperature.temp[2].hum + '%)' : ""
                                                                )
                                                            ),
                                                            temperature.temp[3].temp < 150 && React.createElement(
                                                                'tr',
                                                                null,
                                                                React.createElement(
                                                                    'td',
                                                                    null,
                                                                    'T4'
                                                                ),
                                                                React.createElement(
                                                                    'td',
                                                                    null,
                                                                    temperature.temp[3].temp,
                                                                    React.createElement(
                                                                        'sup',
                                                                        null,
                                                                        '\xBA'
                                                                    ),
                                                                    temperature.temp[3].hum > 0 ? '(' + temperature.temp[3].hum + '%)' : ""
                                                                )
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        ) : null
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }], [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(props, state) {
            var _ref4 = '',
                stateClass = _ref4.stateClass,
                stateIconClass = _ref4.stateIconClass,
                label = _ref4.label;
            var t = props.t;

            if (props.device !== undefined) {
                if (props.device.assetsIOTInfo !== undefined) {
                    if (props.device.assetsIOTInfo[0].tipoTrama === "ONM") {
                        stateClass = 'map-green-bg';
                        stateIconClass = 'icon-road2';
                        label = t("map.sidebar.filtersDevices.driving");
                    }
                    if (props.device.assetsIOTInfo[0].tipoTrama === "OFM") {
                        stateClass = 'map-green-bg';
                        stateIconClass = 'icon-road2';
                        label = t("map.sidebar.filtersDevices.driving");
                    }
                    if (props.device.assetsIOTInfo[0].tipoTrama === "ONS") {
                        stateClass = 'map-yellow-bg';
                        stateIconClass = 'icon-stop_sign';
                        label = t("map.sidebar.filtersDevices.stop");
                    }
                    if (props.device.assetsIOTInfo[0].tipoTrama === "OFS") {
                        stateClass = 'map-red-bg';
                        stateIconClass = 'icon-parking';
                        label = t("map.sidebar.filtersDevices.parked");
                    }
                    if (props.device.assetsIOTInfo[0].tipoTrama === "OFGPRS") {
                        stateClass = 'map-blue-bg';
                        stateIconClass = 'icon-no_gprs';
                        label = t("map.sidebar.filtersDevices.noGprs");
                    }
                    if (props.device.assetsIOTInfo[0].tipoTrama === "OFGPS") {
                        stateClass = 'map-violet-bg';
                        stateIconClass = 'icon-no_gps';
                        label = "No GPS";
                    }
                    if (props.device.assetsIOTInfo[0].tipoTrama === "OFINS") {

                        stateClass = 'map-black-bg';
                        stateIconClass = 'icon-radar';
                        label = "Pendiente de instalación";
                    }
                    // let noGprs = props.transformDateAndCompare(props.device.assetsIOTInfo[0].gpsInfo.timestampApi);
                    // if (noGprs) {
                    //     stateClass = 'map-blue-bg';
                    //     stateIconClass = 'icon-no_gprs';
                    //     label = t("map.sidebar.filtersDevices.noGprs");
                    // }
                } else {
                    if (props.device.assetsIOTInfo[0].tipoTrama === "ONM") {
                        stateClass = 'map-green-bg';
                        stateIconClass = 'icon-road2';
                        label = t("map.sidebar.filtersDevices.driving");
                    }
                    if (props.device.assetsIOTInfo[0].tipoTrama === "OFM") {
                        stateClass = 'map-green-bg';
                        stateIconClass = 'icon-road2';
                        label = t("map.sidebar.filtersDevices.driving");
                    }
                    if (props.device.assetsIOTInfo[0].tipoTrama === "ONS") {
                        stateClass = 'map-yellow-bg';
                        stateIconClass = 'icon-stop_sign';
                        label = t("map.sidebar.filtersDevices.stop");
                    }
                    if (props.device.assetsIOTInfo[0].tipoTrama === "OFS") {
                        stateClass = 'map-red-bg';
                        stateIconClass = 'icon-parking';
                        label = t("map.sidebar.filtersDevices.parked");
                    }
                    if (props.device.assetsIOTInfo[0].tipoTrama === "OFGPRS") {
                        stateClass = 'map-blue-bg';
                        stateIconClass = 'icon-no_gps';
                        label = t("map.sidebar.filtersDevices.noGprs");
                    }
                    if (props.device.assetsIOTInfo[0].tipoTrama === "OFGPS") {
                        stateClass = 'map-violet-bg';
                        stateIconClass = 'icon-no_gps';
                        label = "No GPS";
                    }
                    if (props.device.assetsIOTInfo[0].tipoTrama === "OFINS") {

                        stateClass = 'map-black-bg';
                        stateIconClass = 'icon-radar';
                        label = "Pendiente de instalación";
                    }
                    // let noGprs = props.transformDateAndCompare(props.device.assetsIOTInfo[0].gpsInfo.timestampApi);
                    // if (noGprs) {
                    //     stateClass = 'map-blue-bg';
                    //     stateIconClass = 'icon-no_gprs';
                    //     label = t("map.sidebar.filtersDevices.noGprs");
                    // }
                }

                return {
                    stateClass: stateClass,
                    stateIconClass: stateIconClass,
                    label: label
                    //activators: props.device.assetsIOTInfo[0].gOUTValue
                };
            }
        }
    }]);

    return layerDevicesContent;
}(Component);

export default withTranslation()(layerDevicesContent);